import { MIOPersistentStore } from "./MIOPersistentStore";

export class MIOInMemoryStore extends MIOPersistentStore {

}